import React from "react";
import { CustomTable } from "components/general/Table/CustomTable";

export default function CxP() {
  return (
    <CustomTable tableID="documents" paginationID="ocDocumentsPagination" />
  );
}
